import { FAILED, LOADING, SUCCESS, CLEAR_MESSAGE, RESET } from './constants';

export const initialState = {
  dataSubMerchantActivationList: {
    data: [],
    meta: { page: 1, totalData: 0, totalPage: 0 },
  },
  dataFilter: {
    regionalId: '',
    provinceId: '',
    cityId: '',
    districtId: '',
    villageId: '',
    status: '',
  },
  dataSubMerchantActivationSubmit: false,
  dataSubMerchantActivationSearch: {},
  dataEditStatusBySubUserId: false,
  dataUploadSubMerchantActivation: [],
  isLoadingSubMerchantActivationList: false,
  isLoadingSubMerchantActivationSubmit: false,
  isLoadingSubMerchantActivationSearch: false,
  isLoadingEditStatusBySubUserId: false,
  isLoadingUploadSubMerchantActivation: false,
  messageSubMerchantActivationList: '',
  messageSubMerchantActivationSubmit: '',
  messageSubMerchantActivationSearch: '',
  messageEditStatusBySubUserId: '',
  messageUploadSubMerchantActivation: '',
};

export default function reducer(state = initialState, action) {
  const { type, data, isLoading, message, key } = action;

  switch (type) {
    case FAILED:
      return {
        ...state,
        [`data${key}`]: initialState[`data${key}`],
        [`isLoading${key}`]: false,
        [`message${key}`]: message,
      };
    case LOADING:
      return {
        ...state,
        [`isLoading${key}`]: isLoading,
        [`message${key}`]: '',
      };
    case SUCCESS:
      return {
        ...state,
        [`data${key}`]: data,
        [`isLoading${key}`]: false,
        [`message${key}`]: '',
      };
    case CLEAR_MESSAGE:
      return {
        ...state,
        [`message${key}`]: '',
      };
    case RESET:
      return {
        ...state,
        [`data${key}`]: initialState[`data${key}`],
        [`isLoading${key}`]: initialState[`isLoading${key}`],
        [`message${key}`]: initialState[`message${key}`],
      };
    default:
      return state;
  }
}
